import { useSortable } from "@dnd-kit/sortable";
import { FiMenu } from "react-icons/fi";
import { PhonicsAudioCard } from "./PhonicsAudioCard";

interface Voice {
  id: string;
  phonemeId: string;
  voiceVariant: number;
  label: "card" | "sound";
  filename: string;
  url: string;
  duration?: number | null;
}

interface SortablePhonicsAudioCardProps {
  voice: Voice;
  isPlaying: boolean;
  onTogglePlay: () => void;
  onDelete: () => void;
  onLabelChange?: (newLabel: "card" | "sound") => void;
  isChangingLabel?: boolean;
}

export function SortablePhonicsAudioCard({
  voice,
  isPlaying,
  onTogglePlay,
  onDelete,
  onLabelChange,
  isChangingLabel,
}: SortablePhonicsAudioCardProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: voice.id,
  });

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="relative">
      {/* Drag Handle */}
      <div
        {...attributes}
        {...listeners}
        className="absolute left-0 top-0 bottom-0 flex items-center px-2 cursor-grab active:cursor-grabbing text-gray-400 hover:text-gray-600 z-10"
      >
        <FiMenu size={20} />
      </div>
      <div className="pl-8">
        <PhonicsAudioCard
          voice={voice}
          isPlaying={isPlaying}
          onTogglePlay={onTogglePlay}
          onDelete={onDelete}
          {...(onLabelChange && { onLabelChange, isChangingLabel })}
        />
      </div>
    </div>
  );
}
